class SiteHamburger extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("DOMContentLoaded", () => {
      this.init();
    });
  }
  init() {
    this.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      document.body.classList.toggle('js-menu-open');
    })
  }
}

customElements.define('site-hamburger', SiteHamburger);
